import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M24,9.5a2,2,0,0,0-1.33-1.88.54.54,0,0,0-.46.06.52.52,0,0,0-.21.41v3.83a.52.52,0,0,0,.21.41.53.53,0,0,0,.46.06A2,2,0,0,0,24,10.5Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M20.5,3.5a1.49,1.49,0,0,0-.7-1.26c-.83-.53-1.47-.09-2.72.52A22.47,22.47,0,0,1,7,5.45.5.5,0,0,0,6.5,6v8.59h0a8.32,8.32,0,0,0,4.6,7.34,1,1,0,0,0,.89-1.8,6.27,6.27,0,0,1-3.48-5.42,22,22,0,0,1,8.55,2.47c1.38.65,1.94,1,2.76.51a1.5,1.5,0,0,0,.68-1.27Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M5,6a.49.49,0,0,0-.15-.36.5.5,0,0,0-.35-.14h-1A3.49,3.49,0,0,0,0,9v2a3.5,3.5,0,0,0,3.52,3.49h1A.5.5,0,0,0,5,14Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }